import { createContext } from 'react';
import { dictionaryList, englishLanguage } from '@constants/languages';
import { ILanguageContextInterface } from './types';

export const LanguageContext = createContext<ILanguageContextInterface>({
  userLanguage: englishLanguage,
  dictionary: dictionaryList.en,
  changeLanguage: null,
});
